import { z } from 'zod';

import { defaultPagingSchema } from '../../../helpers/schemas/defaultPagingSchema';

import { marketingActionsFilterSchema } from './components/MarketingActionsFilter/marketingActionsFilterSchema';

export const marketingActionsValidateSearchSchema = defaultPagingSchema.extend({
	openedMarketingAction: z.string().optional().catch(undefined),
	filter: marketingActionsFilterSchema.optional().catch(undefined),
});
